const OSS = require('ali-oss');

export default function OssClient() {
  // 阿里云数据
  return new OSS({
    region: 'oss-cn-hangzhou', // oss-cn-hangzhou.aliyuncs.com
    accessKeyId: 'LTAI5tMma84qCZRyFB6RcFNP',
    accessKeySecret: '6kN2ryPc8i213708YG74rnrpSLNEJz',
    bucket: 'lama2022',
  });
}
